import React, { useMemo } from 'react';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'grilnica-reactstrap';
var LinksModalContent = function (_a) {
    var error = _a.error, closeModal = _a.closeModal;
    var renderBodyContent = useMemo(function () {
        var _a;
        if (!(error === null || error === void 0 ? void 0 : error.errorMessage)) {
            return null;
        }
        var item = [];
        var links = ((_a = error === null || error === void 0 ? void 0 : error.objectsMap) === null || _a === void 0 ? void 0 : _a.links) || [];
        var linksLength = links.length;
        for (var i = 0; i < linksLength; i++) {
            var link = links[i].link;
            var linkName = links[i].linkName;
            item.push(React.createElement("a", { key: link + i, className: 'sec-subtitle1 word-break-word ' + (i < linksLength - 1 ? 'mb-x4' : 'mb-0'), href: link, title: linkName ? linkName : undefined, target: '_blank', rel: 'noopener noreferrer' }, linkName ? linkName : link));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("p", { className: 'sec-subtitle1 text-gray900 ' + ((error === null || error === void 0 ? void 0 : error.objectsMap) ? 'mb-x6' : 'mb-0') }, error.errorMessage),
            item.length > 0 ? (React.createElement("div", { className: 'd-flex flex-column align-items-start justify-content-start' }, item)) : null));
    }, [error]);
    var renderContent = useMemo(function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(ModalHeader, { isModalAdmin: true },
                React.createElement("p", { className: 'text-head-e-modal mb-0' }, "\u041E\u0448\u0438\u0431\u043A\u0430")),
            React.createElement(ModalBody, { isModalAdmin: true }, renderBodyContent),
            React.createElement(ModalFooter, { isModalAdmin: true },
                React.createElement(Button, { type: 'button', color: 'primary', size: 'sm', onClick: closeModal }, "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"))));
    }, [closeModal, renderBodyContent]);
    return React.createElement(React.Fragment, null, renderContent);
};
export { LinksModalContent };
//# sourceMappingURL=LinksModalContent.js.map